export const collectionOrder = [
  'Bryant',
  'Bryant Petite',
  'Bryant Slipcovered',
  'Holt',
  'Holt Petite',
  'Camden',
  'Sebastian',
  'Maurice',
  'Carin',
  'Haine',
  'Daya',
  'Logan',
  'Antony',
  'Diane',
];

export const collectionQuickLinks = [
  'Bryant',
  'Holt',
  'Camden',
  'Sebastian',
  'Maurice',
  'Carin',
  'Haine',
  'Daya',
  'Logan',
  'Antony',
  'Diane',
];
